<template>
  <base-viewer>
    <navDrawer :hover="true"/>
    <Navbar />
    <v-content style="padding: 104px 0px 0px;">
      <v-scroll-x-transition hide-on-leave>
        <router-view />
      </v-scroll-x-transition>
    </v-content>
    <Footer :show="true"/>
  </base-viewer>
</template>

<script>
import Navbar from "@/core/components/Navbar.vue";
import NavDrawer from '@/core/components/navigation';
import Footer from "@/core/components/footer";

export default {
  components: {
    Navbar,
    Footer,
    NavDrawer,
  },
  methods:{
  }
};
</script>

